import { getNumberComma } from '../utils/numberUtils';

// 메인화면 위젯 요약(WidgetSummaryDto) 공통 포맷 유틸.
// GenericWidgetContainer와 KpiStrip이 같은 포맷 규칙을 쓰도록 여기로 추출했다
// (비주얼 리뉴얼, 2026-10-23) - 숫자 포맷이 둘 사이에서 갈라지면 카드와 상단 띠의
// 숫자가 미묘하게 달라 보일 수 있다.
export const formatMetric = (metric) => {
  if (!metric) return '';
  const value = metric.value || 0;
  // 재검토 2(Fable, 2026-10-23) §6-8: 음수 통화가 "₩-1,234"로 보였다(부호가 ₩ 뒤에 붙음) -
  // "-₩1,234" 스타일로 부호를 ₩ 앞으로 뺀다.
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  // getNumberComma(0)은 falsy 분기라 "-"를 돌려준다(utils/numberUtils.js, 기존 동작) - 값이
  // 진짜 0건인 위젯(예: 결재 대기 0건)이 KPI 띠에서 "-건"으로 보이면 "데이터 없음"처럼 읽혀
  // 혼동을 준다(2026-10-23 비주얼 리뉴얼 중 KPI 띠 실측에서 발견). 0은 0으로 보여준다.
  const n = abs === 0 ? '0' : getNumberComma(abs);
  if (metric.unit === 'currency') return `${sign}₩${n}`;
  if (metric.unit === 'percent') return `${sign}${n}%`;
  return `${sign}${n}건`;
};

export const isEmptySummary = (summary) => {
  const metricZero = !summary.metric || !summary.metric.value;
  const noRows = !summary.rows || summary.rows.length === 0;
  // 재검토 2(Fable, 2026-10-23) §6-8: 월 마감 체크(MANAGE_MONTH_CLOSE)는 완료=0건이어도
  // 계획(target)이 있으면 "데이터 없음"이 아니다 - target도 같이 봐야 한다(기존엔 b.value만
  // 봐서 "발행 완료 0 / 계획 12"인 달에도 빈 카드로 보였다).
  const noBars = !summary.bars || summary.bars.every((b) => !b.value && !b.target);
  return metricZero && noRows && noBars;
};

export const buildLinkTo = (link) => {
  const query = link.query || {};
  const qs = Object.keys(query)
    .filter((k) => query[k] !== undefined && query[k] !== null && query[k] !== '')
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
    .join('&');
  return qs ? `${link.path}?${qs}` : link.path;
};
